import { Component, Input, OnInit } from '@angular/core';
import { CalibrationService } from 'src/app/Service/Calibration/Calibration.service';

@Component({
  selector: 'app-DataEntityDeviceInfoView',
  templateUrl: './DataEntityDeviceInfoView.component.html',
  styleUrls: ['./DataEntityDeviceInfoView.component.scss']
})
export class DataEntityDeviceInfoViewComponent implements OnInit {

  @Input() inner_deivce_id: number = 0
  Token: String = ''
  
  customerName: String = ''
  code: String = ''
  expert: String = ''
  newDevice: String = ''
  oldDevice: String = ''
  dsc: String = ''

  constructor(
    private Calibration_Service: CalibrationService,
  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.ReadData_Calibration_Request()
  }

  ReadData_Calibration_Request(){
    this.Calibration_Service.GetCalibrationRelativeDeviceNameDetail(this.Token,this.inner_deivce_id).subscribe(
      data=>{
        this.customerName=data['customerName']
        this.code=data['code']
        this.expert=data['expert']
        this.newDevice=data['newDevice']
        this.oldDevice=data['oldDevice']
        this.dsc=data['oldDevice']
      }
    )
  }


}
